// extracted by mini-css-extract-plugin
export var dateLabel = "_37-0";
export var dateLabelError = "_37-1";
export var fullWidth = "_37-2";
export var smaller = "_37-3";